import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'ngx-page-container',
  templateUrl: './page-container.component.html',
  styleUrls: ['./page-container.component.scss'],
})
export class PageContainerComponent implements OnInit {

  constructor() {
  }

  ngOnInit() {

  }

}
